import React from 'react';

import { noop } from 'lodash';

const defaultValue = {
  messagePolite: '',
  messageAssertive: '',
  announcePolite: noop as (message: string) => void,
  announceAssertive: noop as (message: string) => void,
};

const LiveAnnouncerContext = React.createContext(defaultValue);
const { Provider, Consumer } = LiveAnnouncerContext;

export { LiveAnnouncerContext, Provider, Consumer };
